// Libraries
import store from 'store'
import React, { lazy, Suspense } from 'react'
import { render } from 'react-dom'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'

// Components
import { GlobalStyle } from 'styles'
import { isRulexSelected } from 'utils'
const App = lazy(() => import('app'))
const Login = lazy(() => import('./login'))
const AppSelect = lazy(() => import('./appSelect'))

const PrivateRoute = ({ component: Component, ...rest }) => {
  const hasToken = store.get('AUTH_TOKEN')

  return (
    <Route
      {...rest}
      render={props =>
        hasToken ? <Component {...props} /> : <Redirect to='/login' />
      }
    />
  )
}

const Routes = () => {
  const urlHome = isRulexSelected() ? 'asignacion/reglas' : 'filtex/filtros'

  return (
    <React.Fragment>
      <GlobalStyle />
      <BrowserRouter>
        <Suspense fallback={<div></div>}>
          <Switch>
            <Route path='/login' component={Login} />
            <Route path='/selecciona-app' component={AppSelect} />
            <Redirect exact from='/' to={urlHome} />
            <Redirect exact from='/asignacion' to={'asignacion/reglas'} />
            <Redirect
              exact
              from='/disponibilidad'
              to={'disponibilidad/reasignacion'}
            />
            <PrivateRoute path='/' component={App} />
          </Switch>
        </Suspense>
      </BrowserRouter>
    </React.Fragment>
  )
}

render(<Routes />, document.getElementById('app'))
